import { I18n } from "@assets/strings";
import moment from "moment";
import React, { useState } from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import transactionImage from "@assets/images/transaction_illustration.svg";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Group } from "@domain/group/group";
import { useShareroomAlias, useTransactionLists } from "@domain/wallet/hook";
import { TransactionFilterOptions } from "@domain/wallet/wallet";
import { useModalTools } from "@ui/modals/modalContext";
import { mobile } from "@ui/styles/utils";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { EmptyTable } from "@ui/components/wallet/EmptyTable";
import { TransactionsList } from "@ui/components/wallet/transactionsList";
import { SeemoreTransaction } from "@ui/components/group/shareroom/dashboard/seemore/seemoreTransaction";

interface LastTransactionsOnMobileProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}
export const LastTransactionsOnMobile: React.FC<LastTransactionsOnMobileProps> = () => {
	const currentProfile = useCurrentProfile();
	const currentLanguage = currentProfile?.language === "ENGLISH" ? "en" : "fr";
	moment.locale(currentLanguage);
	const [filterOption] = useState<TransactionFilterOptions | undefined>(undefined);
	const shareroomAlias = useShareroomAlias();
	const { createModal } = useModalTools();
	const {
		result: transactions,
		loading,
		fetchMore,
		totalElements,
	} = useTransactionLists(filterOption, shareroomAlias ?? undefined);
	return !loading ? (
		<ContentBlock>
			<StyledHeader>
				<ContainerDescriptionHisto>
					<StyledTitle>{I18n.t("shareroom.dashboard.transactions.history.title")}</StyledTitle>
					<StyledDescription>{I18n.t("shareroom.dashboard.transactions.history.description")}</StyledDescription>
				</ContainerDescriptionHisto>
				{/* <ContainerActions>
					<Selecter
						value={filterOption?.period}
						onChange={(v: string) => setFilterOption({ ...filterOption, period: v as FilterType })}
						options={allFilterType.map((val) => ({
							value: val,
							label: I18n.t(`filter.${val}`),
						}))}
						chevronColor="#206AF8"
						placeholder={I18n.t("filter_button")}
					/>
					<DownloadIcon>
						<img src={downloadSvg} />
					</DownloadIcon>
				</ContainerActions> */}
			</StyledHeader>

			{!totalElements && !loading ? (
				<EmptyTable source={transactionImage} />
			) : (
				<ContainerTransaction>
					<ShowMore onClick={() => createModal((close) => <SeemoreTransaction close={close} />)}>
						{I18n.t("see_more")}
					</ShowMore>
					<InfiniteScroll loading={loading} onEndReached={fetchMore}>
						<TransactionsList transactions={transactions.slice(0, 5)} />
					</InfiniteScroll>
				</ContainerTransaction>
			)}
		</ContentBlock>
	) : (
		<ContainerClipLoader>
			<ClipLoader />
		</ContainerClipLoader>
	);
};

const ContentBlock = styled(RoundedBlock)`
	@media ${mobile} {
		padding: 22px;
	}
`;
const StyledHeader = styled.div`
	display: flex;
	flex-direction: row;
	margin-bottom: 30px;
`;

const ContainerDescriptionHisto = styled.div``;

// const ContainerActions = styled.div`
// 	display: flex;
// 	flex-direction: row;
// 	justify-content: center;
// 	align-items: center;
// 	position: absolute;
// 	right: 0;
// 	margin-right: 30px;
// `;

// const DownloadIcon = styled.div`
// 	margin-left: 10px;
// 	margin-top: 8px;
// `;
const StyledTitle = styled.div`
	width: 116px;
	font-weight: 600;
	font-size: 14px;
	line-height: 26px;
`;

const StyledDescription = styled.div`
	font-weight: 400;
	font-size: 10px;
	line-height: 26px;
`;

const ContainerTransaction = styled.div`
	display: flex;
	flex-direction: column;
`;
const ShowMore = styled.div`
	display: flex;
	justify-content: flex-end;
	font-size: 14px;
	line-height: 26px;
	${({ theme }) => theme.textStyles.text};
	color: ${({ theme }) => theme.colors.secondary};
	margin-bottom: 20px;
	cursor: pointer;
`;

const ContainerClipLoader = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;
